import { inputFieldFloatingLabelBlueprint } from "@made-people/blueprint-form/blueprint";

inputFieldFloatingLabelBlueprint.override({
  slots: {
    base: "w-full",
    inputWrapper: "flex flex-col gap-2",
    input:
      "peer block order-2 text-text-less-emphasis-1 bg-white  border border-solid border-neutral-200 appearance-none focus:outline-none focus:ring-0 focus:border-black focus:text-black autofill:bg-white",
    label: "order-1 text-label-sm uppercase !font-medium !tracking-wide",
    helperText:
      "mt-2 text-body-xs order-3 text-red-500 data-[is-type='error']:text-system-error data-[is-type='warning']:text-system-warning data-[is-type='info']:text-system-info",
  },
  variants: {
    size: {
      sm: {
        input: "px-2 h-10 items-center w-full text-body-sm",
        label: "text-body-xs top-4",
      },
      md: {
        input: "px-2.5 h-12 w-full text-body-md",
      },
      lg: {
        base: "",
      },
    },
  },
  defaultVariants: {
    size: "md",
  },
});
